__turbopack_context__.v({
  "active": "Modal-module-scss-module__vzGZ_q__active",
  "overlay": "Modal-module-scss-module__vzGZ_q__overlay",
});
